import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

import Icon from "./Icon";

const LANGUAGES = [
  { value: "pt", label: "Português", short: "PT" },
  { value: "en", label: "English", short: "EN" },
  { value: "en-insieme", label: "English - INSIEME", short: "EN" },
  { value: "es", label: "Español", short: "ES" },
];

/* Topbar language picker — icon button with a rec-pop menu. The selection is
   persisted by i18next-browser-languagedetector (localStorage). */
export default function LanguageMenu({ variant }) {
  const { t, i18n } = useTranslation(["sidenav"]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  const language = i18n.language || "en";
  const current = LANGUAGES.some((lang) => lang.value === language)
    ? language
    : language.split("-")[0];

  const pick = (value) => {
    i18next.changeLanguage(value);
    setOpen(false);
  };

  const options = LANGUAGES.map((lang) => (
    <button
      key={lang.value}
      type="button"
      className={`rec-pop-opt${current === lang.value ? " on" : ""}`}
      onClick={() => pick(lang.value)}
    >
      <span className="font-bold text-[11px] w-[24px]">{lang.short}</span>
      {lang.label}
      {current === lang.value && <Icon name="check" style={{ fontSize: 16, marginLeft: "auto" }} />}
    </button>
  ));

  if (variant === "inline") {
    return options;
  }

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        className="rec-icon-btn"
        onClick={() => setOpen((o) => !o)}
        title={t("topbar.language", { defaultValue: "Idioma" })}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <Icon name="language" />
      </button>
      {open && <div className="rec-pop !min-w-[180px]">{options}</div>}
    </div>
  );
}

LanguageMenu.propTypes = {
  variant: PropTypes.oneOf(["button", "inline"]),
};

LanguageMenu.defaultProps = {
  variant: "button",
};
